import React from 'react';
import Footer from '../components/Footer';
import Header from '../components/Header';

export default function ExplorarComidasArea() {
  return (
    <section className="content-container">
      <Header title="Explorar Origem" className="alternative-header" />
      <Footer />
    </section>
  );
}
